import { request } from "../helpers/utility";

let instance = null;

export default class RotaRoleResources {
    constructor() {
        if (!instance) {
            this.url = 'admin/rota/';
            this.rotadatesurl = 'admin/rota/dates';
            this.rotaroles = 'admin/rota-roles';
            instance = this;
        }
        return instance;
    }

    // Get all rota roles
    getRoles() {
        return request.GET(this.rotaroles);
    }

    // Create a new rota role
    createRole(name, isCoreRole = false) {
        return request.POST(this.rotaroles, {
            name: name,
            is_core_role: isCoreRole
        });
    }

    // Update a rota role
    updateRole(roleId, name) {
        return request.PUT(`${this.rotaroles}/${roleId}`, {
            name: name
        });
    }

    // Delete a rota role
    deleteRole(roleId) {
        return request.DELETE(`${this.rotaroles}/${roleId}`);
    }

}